import { useEffect } from "react";

const values = [
  {
    icon: "ri-lightbulb-flash-line",
    title: "Creativity",
    description:
      "We foster original thinking and bold creative expression in everything we do.",
  },
  {
    icon: "ri-team-line",
    title: "Community",
    description:
      "Building tight-knit, supportive circles where every creator lifts others.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Monetization",
    description:
      "We teach creators how to turn their passion into sustainable income streams.",
  },
  {
    icon: "ri-heart-line",
    title: "Authenticity",
    description:
      "Real growth comes from being genuine. We encourage each creator to be themselves.",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "Growth",
    description:
      "Continuous improvement, goal setting, and measurable progress for every creator.",
  },
];

export default function ValuesSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-brand-black py-24 md:py-36 section-divider">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16 reveal">
          <span className="text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase block mb-4">
            What We Stand For
          </span>
          <h2 className="font-display font-bold text-white text-4xl md:text-5xl">
            Our Core <span className="text-gradient-gold">Values</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {values.map((val, i) => (
            <div
              key={val.title}
              className={`reveal reveal-delay-${(i % 4) + 1} card-gold bg-brand-card rounded-2xl p-8 text-center group cursor-default hover:bg-gold/90 transition-all duration-400`}
              style={{ transitionDuration: "0.4s" }}
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto rounded-2xl border border-gold/30 bg-gold/5 mb-5 group-hover:bg-white/15 group-hover:border-white/30 transition-all duration-400">
                <i
                  className={`${val.icon} text-gold text-2xl group-hover:text-white transition-colors duration-400`}
                />
              </div>
              <h3 className="font-display font-bold text-white text-xl mb-3 group-hover:text-white transition-colors duration-400">
                {val.title}
              </h3>
              <p className="text-white/50 text-sm font-sans leading-relaxed group-hover:text-white/80 transition-colors duration-400">
                {val.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
